module.exports = __webpack_public_path__ + "img/free-fire.0ffab3e.png";